import React, { FunctionComponent, useEffect, useState } from 'react'
import { CurrentUserType } from '../../ducks/auth'
import Amplitude from '../../utils/amplitudeHelper'
import LoadIcon from '../../components/LoadIcon'
// import { BtnContainer, BtnWrapper } from './styled'

interface LobbyTour {
  currentUser: CurrentUserType
}

const LobbyTour: FunctionComponent<LobbyTour> = ({ currentUser }) => {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    Amplitude.visit('Lobby')
  }, [currentUser.id])

  return (
    <>
      {loading && <LoadIcon />}
      <iframe
        style={{ height: '100vh', width: '100%', overflow: 'hidden', border: 'none' }}
        allowFullScreen={false}
        title="Lobby Tour"
        scrolling="no"
        src="/lobby-tour/index.htm"
        onLoad={() => {
          setLoading(false)
        }}
      />
    </>
  )
}

const Lobby = React.memo(LobbyTour)

export default Lobby
